<ncp-table #insurances [(options)]="options"></ncp-table>
